// extracted by mini-css-extract-plugin
module.exports = {"autorenew-button":"subscriptions_autorenewal_button_autorenew-button__5JGeX"};